import script from "./UseCasesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./UseCasesSection.vue?vue&type=script&setup=true&lang=js"

import "./UseCasesSection.vue?vue&type=style&index=0&id=9621ef0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9621ef0c"]])

export default __exports__